import { combineReducers } from '@reduxjs/toolkit';
import captionsReducer from './slices/captions/captionsSlice';
import transcriptionReducer from './slices/transcription/transcriptionSlice';

export default combineReducers({
  transcription: transcriptionReducer,
  captions: captionsReducer,
});
